export default {"src":"/_next/static/media/SG.e942f61f.svg","height":18,"width":18};